import { CloseOutlined, InfoCircleFilled, InfoCircleTwoTone } from '@ant-design/icons';
import { Alert, Button, Col, Divider, Modal, Popover, Row, Space } from 'antd';
import { isEmpty, intersection } from 'lodash';
import React, { ReactElement, useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, withRouter } from 'react-router-dom';
import Panel from '../../../../../../../shared/components/card/Panel';
import { FormCheckBox, FormInputDate, FormInputMobile, FormRadioButton, FormSelect, FormTextInput } from '../../../../../../../shared/components/crmFormElement/FormInput';
import DelayedIntimationPopUP from '../../../../../../../shared/components/DelayedIntimationPopup/DelayedIntimationPopUP';
import { DEFAULT_TEXT, GO_DIGIT_DYNAMIC_TREATMENT_DETAILS_JSON, GUTTOR_SPACE,
  VIDAL_DYNAMIC_TREATMENT_DETAILS_JSON } from '../../../../../../../shared/constants/commonConstants';
import {
  MATERNITY_DIAGNOSIS_TYPE,
  PROCEDURE_OTHER_TYPES,
  OTHER_ID,
  CONCATED_OTHER_TREATMENT_ICDS,
  FINAL_OBSTETRIC_HISTORY,
  OTHER_ROOM_TYPE,
  DOCTOR_QUALIFICATION_DROPDOWN,
  MAX_LOS_ALLOWED_WITHOUT_WARNING,
  HDFC_MATERNITY_DIAGNOSIS_TYPE,  formInputStates, DAY_CARE_TYPE_DRAFT_KEYS, REASON_FOR_HOSPITALIZATION_OPTIONS_GO_DIGIT,
  REASON_FOR_HOSPITALIZATION_OPTIONS, actions, PAYERMASTER_TYPE, CATARACT_EYE_TYPE_ICD_MAPPING, DYNAMIC_FIELD_MAPPINGS,
  DRAFT_KEYS, COMMON_PLT, REASON_FOR_ENHANCEMENT_OPTIONS, REASON_FOR_RECONSDIERATION_OPTIONS,
  SURGICAL,
} from '../../../../../../../shared/constants/crmConstants';
import { useSmoothScroll } from '../../../../../../../shared/hooks/useSmoothScroll';
import { RootState } from '../../../../../../../store';
import { updateSelectedDetail } from '../../../../../../../store/actions/inPatientAction';
import {
  setExtraFormValues, setCardCollapse,
  setExistingClaimError, setIsDischargeCase,
  updateAdditionalMandatoryDocuments,
  updateAutomatedProceduresOptions,
  toggleOtherProcedure,
  updatePackageSelection,
  updateBillDetails,
  toggleOtherRoomType,
  setIsCovidCase,
  setHospitalOtherRoomType,
  setPageChangeAllowed,
  setDynamicQuestionFields,
  setProcedureID,
  setPltID,
  setPLTChanged,
  setPLTMappedValue,
  setsubmitDisabled,
  setShowAccidentCard,
  setConditionOnDischarge,
  setIsDeathCase,
  updateDefaultTimeline,
  checkDuplicateClaim,
  setDelayedAdmission,
  setDefaultClaim,
  setHoursDifference,
  setDiagnosisFromPayerLookUp,
  setProcedureFromPayerLookUp,
  setSelectedDoctorList,
  sethospDetailsForRoomType,
} from '../../../../../../../store/actions/newAdmissionAction';
import { PayerInitialState } from '../../../../../../../store/models/payerListModel';
import { base64UrlEncode } from '../../../../../../../utils/utility';
import {
  findKeyValuePair, getFilteredProcedureList,
  getIsPageNameDetail, getIsPageNameEdit, getIsPageNameNewAdmission,
  getSelectedDiagnosisIds, getSelectedDiagnosisName, setIsShowNow,
  // getLookUpFullDetail,
  customGTMEvent, getPayerConfigPropValue,
  getIsPageNameEditDischarge, isValidStayLength,
  checkIfDelayedAdmsission, convertToISOStrings, checkIsLazyLoadingMaster,
  getIsPageNameReconsider,
  getLookUpFullDetail,
  handleUserFocus,
  validateDateRange,
  shouldShowDayCareTag,
  isInitialDischargeEnabled,
  shouldShowDayCareInDraftFlow,
  getExactDoctorMatch,
  getPLTValue,
  prefillHISDynamicFields,
  shouldShowReasonForReconsideration,
  shouldShowReasonForEnhancement,
} from '../../../../service/crmUtils';
import { AdmissionContext } from '../../../AdmissionContext';
import ClaimDetailHeader from '../ClaimDetailHeader/ClaimDetailHeader';
import CONTROL_CONFIG_BASED_ON_PAYER from '../../../../../../../config/formControlConfig';
import PopuponLateDod from '../../../../../../../shared/components/PopuponLateDOD/PopuponLateDod';
import AutomatedOtherTreatmentDetailCard from '../OtherTreatmentDetailCard/AutomatedOtherTreatmentDetailCard';
import DynamicTreatmentDetailCard from '../DynamicTreatmentDetailCard/DynamicTreatmentDetailCard';
import {
  fetchProviderSpecificRoomType, setSynonymValue, setTreatmentValue,
  otherTreatmentSelected, setDiagnosisValue, setDynamicLookUpForDiagnosis, setDynamicLookUp,
  getHISTreatmentValuesFromLookUp,
  fetchLookup,
} from '../../../../../../../store/actions/lookUpAction';
import _ from 'lodash';
import FormTextArea from '../../../../../../../shared/components/crmFormElement/FormTextArea/FormTextArea';
import { LookUpState } from '../../../../../../../store/models/lookUpModel';
import ApplicationDetail from '../../../../../../../shared/services/applicationDetail.service';
import FormAutoCompleteWithPrefix from '../../../../../../../shared/components/crmFormElement/FormAutoComplete/FormAutoCompleteWithPrefix';
import DatePickerInput from '../../../../../../../shared/components/crmFormElement/FormInputDatepicker';
import { debounce } from 'lodash';
import DatePickerLabel from '../../../../../../../shared/components/DatePicker/DatePickerLabel';
import { ControlConfig } from '../../../../../../../shared/models/formControlConfig.model';
import { setHISTreatmentValuesFromLookUp } from '../../../../../../../store/actions/hospitalAction';
import { ICICI_PROCEDURES } from '../../../../../../../shared/constants/crmConstants';

const AutoTreatmentDetailCard = ({ isLoading, form, location: { pathname }, buddhimedForm }: any): ReactElement => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [isLOSgtWarning, setIsLOSgtWarning] = useState(false);
  const [lengthOfStay, setLengthOfStay] = useState(0);
  const [isProcedureMapped, setIsProcedureMapped] = useState(false);
  const [isDelayModalVisible, setIsDelayModalVisible] = useState(false);
  const [disableHospRoom, setDisableHospRoom] = useState(false);
  const [dateDifference, setDateDifference] = useState(0);
  const [treatmentMapped, setTreatmentMapped] = useState({});
  // const [specialityData, setSpecialityData] = useState('');
  const [synonymResponse, setSynonymResponse] = useState([]);
  const [countProceduresMapped, setCountProceduressMapped] = useState(0);
  const [diagnosisDropDownOptions, setDiagnosisDropDownOptions] = useState([] as any);
  const [procedureDropDownOptions, setProcedureDropDownOptions] = useState([] as any);
  const [popConfirmCancel, setPopConfirmCancel] = useState(false);
  const [delayedIntimationCancel, setDelayedIntimationCancel] = useState(false);
  const [dateChanged, setDateChanged] = useState(false);
  const [isRoomTypeLoading, setIsRoomTypeLoading] = useState(false);
  const {
    payerLookUp = {}, lookUp, payerList: { payer: { uniqueIdentifier, isOnMailPayer, name, isRpaPayer } },
    newAdmission: { selectedBeneficiaryDetail = {}, extraFormValues = {}, cardCollapse, defaultTimeline,
      admissionFormVal, existingClaimError, automatedProcedureOptions, showOtherProcedure, showOtherRoomType, isDateApplied,
      disableRoomType, isDraftSelected, automatedProcedureId, selectedPackage, proposedLineTreatmentId, isPLTChanged, pltMappedValue,
      submitDisabled, isDeathCase, diagnosisSelectedValues, procedureSelectedValues, isDaycareCase,
      hospDetailsForRoomType, selectedDraft : { rawDraft },
    },
    admissionDetails: { claimDetails: {isDischarge, isDeathCase: isDeathCaseFromClaim} },
    selectedInPatientDetail: { isDraftBtnClicked },
    nhcx: {selectedPolicyDetail},
  } = useSelector((state: RootState): RootState => state);
  const { diagnosisDynamicLookup, procedureDynamicLookup }: any = useSelector((state: RootState): LookUpState => state.lookUp);
  const { selectedPatientDetail, HISTreatmentLookUpValues, parsedHISFieldValues } = useSelector((state: RootState): any => state?.hospital);
  const { claimDetails } = useSelector((state: RootState): any => state.admissionDetails);
  const { treatmentAdditionalAttrs } = parsedHISFieldValues || {};
  const { eye, approach } = treatmentAdditionalAttrs || {};
  const { payer, formControlConfig } = useSelector((state: RootState): PayerInitialState => state.payerList);
  const isDelayedAdmission = useSelector((state: RootState): boolean => state.newAdmission.isDelayedAdmission || false);
  const { customerDetail, treatmentDetail, billDetail } = admissionFormVal || {};
  const { doctorList = [], providerRoomType = [], roomType: payerRoomTypeOptions = [], diagnosis: payerDiagnosisOptions = [],
    procedure: payerProcedureOptions = [], automationProcedures: payerAutomationProcedures} = payerLookUp[uniqueIdentifier] || {};
  const [disableDocRegNo, setDisableDocRegNo] = useState(false);
  const admissionContext = useContext(AdmissionContext);
  const { claimDetailBackup } = admissionContext;
  const isNewAdmissionPage = getIsPageNameNewAdmission(pathname);
  const { policyStartDate, policyEndDate }: any = selectedBeneficiaryDetail || {};
  const { roomType: rType = '' } = form.getFieldsValue(['roomType']) || {};
  claimDetailBackup.roomType = rType;
  const isDetailPage = getIsPageNameDetail(pathname);
  const isEditDischarge = getIsPageNameEditDischarge(pathname);
  const dynamicQuestionFields = [] as any;
  useSmoothScroll('treatment-scroll');
  // const prevTreatmentDetail = usePrevious(treatmentDetail);
  const payerConfig = CONTROL_CONFIG_BASED_ON_PAYER[name];
  const payerConfigValues = Object.values(payerConfig || '');
  const payerConfigValueObjectFromRedux = Object.values(formControlConfig || '');
  let formElementCount: any[] = [];
  let dateValidationCount: any[] = [];
  const max = payerConfigValues?.filter(({ label, MAX }: any): boolean => (label === 'Present Complaints' || label === 'DIAGNOSIS') && MAX);
  const maximumValue = (max?.map((ele: any): any => ele?.MAX)?.length > 0 ) ? max?.map((ele: any): any => ele?.MAX) : false;
  const fieldLength = maximumValue ? max?.map((ele: any): any => ele?.maximumLength) : null;
  const isAlphabetsOnly = payerConfigValues?.filter(({type, hidden}: any): boolean => type === 'onlyAlpha' && !hidden)?.length;
  const showCard = Boolean(payerConfigValues?.filter(({ type, hidden }: any): boolean => type === 'showNone' && !hidden)?.length);
  const maxPropObj = payerConfigValues?.filter(({ MAX }: any): boolean => MAX);
  const updateRoomTypeICICI = payerConfigValues?.filter(({ type }: any): boolean => type === 'ICICI_ROOMTYPE')?.length;
  const productCodeInBenefPayer = payerConfigValues?.some((config: any): any => Boolean(config?.showProductName));
  const isRoomTypeWithoutOthers = payerConfigValueObjectFromRedux?.some(({removeOther}: any): boolean => removeOther);
  const customOptions: any = payerConfigValueObjectFromRedux?.filter(({ optionsType }: ControlConfig): boolean => optionsType === 'customOptions');
  const preFillICD10PCS = payerConfigValueObjectFromRedux?.some(({ type }: any): boolean => type === 'prefillICD10PCSTrue');
  let doaDifferenceLimit: number;
  let doaLeftLimitValidation;
  let dodForValidation;
  let doaRightLimitValidation;
  const [isFieldsChanged, setIsFieldsChanged] = useState(false);
  const isHISSearchEnabled = ApplicationDetail.instance.getIsHISSearchEnabled();
  const {hisDoctorList} = useSelector((state: RootState): any => state.hospital);
  const diagnosisValue = [] as any;
  const { lazyLoadMasterTypes, isInitialDischargeEnabledPayer, diagnosisProcedureMappingConfig } = payer || {};
  const parsedDiagProcMappingConfig = diagnosisProcedureMappingConfig ? JSON.parse(diagnosisProcedureMappingConfig) : {};
  const parsedDiagProcMappingConfigLen = !isEmpty(parsedDiagProcMappingConfig);
  const isDisableDODRequired = payerConfigValues?.some(({ disableDODSelection }: any): boolean =>
    disableDODSelection);
  // payerLookUp?.diagnosisMasterLookup ? Object.keys(payerLookUp?.diagnosisMasterLookup) : [];
  const GO_DIGIT_PAYER = payerConfigValues.some(({options }: any): boolean => options === 'GO_DIGIT_MATERNITY_TYPE_OPTIONS');
  if (payerConfig) {
    formElementCount = payerConfigValues?.filter(({ type, hidden }: any): boolean => type === 'DELAY_ADMISSION_REMARK' && !hidden);
    dateValidationCount = payerConfigValues?.filter(({ type, hidden }: any): boolean => type === 'DATE_VALIDATION' && hidden);
    const delayAdmissionObject = formElementCount[0];
    const dateValidationObject = dateValidationCount[0];
    doaDifferenceLimit = delayAdmissionObject?.['doaLimit'] ? delayAdmissionObject['doaLimit'] : 3;
    dodForValidation = dateValidationObject?.['dodLimitValid'] ? dateValidationObject['dodLimitValid'] : undefined;
    doaLeftLimitValidation = dateValidationObject?.['doaLeftLimit'] ? dateValidationObject['doaLeftLimit'] : undefined;
    doaRightLimitValidation = dateValidationObject?.['doaRightLimit'] ? dateValidationObject?.['doaRightLimit'] : undefined;
  }
  const [inputStates, setInputStates] = useState(formInputStates.treatmentDetailsform);
  const { treatmentDetails, doctorDetails } = selectedPatientDetail || {};
  const noFreeTextDiagnosis = payerConfigValueObjectFromRedux?.some((config: any): any => config?.mode === 'multipleNoFreeText');
  const commonDetail = { isLoading, form, claimDetailBackup };
  const isDoctorNameFilled = form?.getFieldValue()?.doctorName;
  const doctorName = isDraftSelected ? (admissionFormVal?.customerDetail?.doctorName ||
    admissionFormVal?.treatmentDetail?.doctorName) : isDoctorNameFilled;
  const { procedureType, statusId } = claimDetails || {};
  const stayLengthUpdated = form?.getFieldsValue()?.stayLength;
  const isNotNewAdmissionPage = !isNewAdmissionPage || isDraftBtnClicked;
  const parsedDraftData = !isEmpty(rawDraft) ? JSON?.parse(rawDraft) : {};
  const { nextAllowStatus, payerClaimExtensionFields } = claimDetails || {};
  const { draftKey } = parsedDraftData || {};
  const [status] = nextAllowStatus || '';
  const appDetail = ApplicationDetail.instance;
  const isInitialDischargePayer = isInitialDischargeEnabled(appDetail.getIsInitialDischargeEnabledProvider(),
    isDaycareCase, isInitialDischargeEnabledPayer);
  const { stayLength, fullName } = form.getFieldsValue(['stayLength', 'fullName']);
  const showDayCareInDraftFlow = shouldShowDayCareInDraftFlow(draftKey, DAY_CARE_TYPE_DRAFT_KEYS);
  const doctorRegNo = isDraftSelected ? (admissionFormVal?.treatmentDetail?.doctorRegNo) :
  form.getFieldValue('doctorRegNo');
  const draftTreatmentDetails = parsedDraftData?.newFormValue?.treatmentDetail;
  // Using a ref to track if room type has been prefilled
  const hasPrefilledRoomTypeRef = useRef(false);
  const { proposedLineOfTreatmentFromForm } = treatmentDetail;
  const [HISTreatmentValues, setHISTreatmentValues] = useState({} as any);
  const [HISlookupIDs, setHISlookupIDs] = useState([] as any);
  const formPltSelectedValue = form?.getFieldsValue(['proposedLineOfTreatment'])?.proposedLineOfTreatment;
  const isHDFCEnabled = Boolean(payer?.shortName === 'HDFC' && process.env.REACT_APP_HDFC_FEATURES === 'true');
  const automatedProcedureFieldValue = form.getFieldsValue('automatedProcedure');
  const isEnhancement = getIsPageNameEdit(pathname);
  const isReconsider = getIsPageNameReconsider(pathname);

  useEffect((): void => {
    if (!isRoomTypeLoading) {
      setIsRoomTypeLoading(true);
      // removed check on insurer to ensure that the API is called for all payers once
      if (!updateRoomTypeICICI) {
        let payerInsurerId = null;
        // find insurer ID from payerLookUp
        const lookupResult =
          findKeyValuePair(payerLookUp[uniqueIdentifier]?.insurerName, 'name', customerDetail?.insurerName) ||
          findKeyValuePair(payerLookUp[uniqueIdentifier]?.insurerName, 'value', customerDetail?.insurerName) ||
          {};
        payerInsurerId = lookupResult.payerMasterId != null ? lookupResult.payerMasterId : claimDetails.insurerName || '';
        // Only fetch if insurerId differs from what we already have
        if ((hospDetailsForRoomType.insurerId !== payerInsurerId || payer.id !== hospDetailsForRoomType.payerId)) {
          dispatch(fetchProviderSpecificRoomType((payerInsurerId || ''), onSuccess));
        }
      }
    }
  }, [ payer ]);

  useEffect((): void => {
    // checking hosptialroomtype value is present in payerlookup or not
    if (isNotNewAdmissionPage && !isEmpty(hospDetailsForRoomType) && claimDetails?.hospitalRoomType &&
      claimDetails?.hospitalRoomType !== OTHER_ID &&
      claimDetails?.hospitalRoomType !== 'Others') {
      const { providerRoomType: hospitalRoomTypeValue } =
        findKeyValuePair(payerLookUp?.[uniqueIdentifier]?.providerRoomType, 'name', claimDetails?.hospitalRoomType) ||
        findKeyValuePair(payerLookUp?.[uniqueIdentifier]?.providerRoomType, 'value', claimDetails?.hospitalRoomType) || {};
      if (hospitalRoomTypeValue === undefined) {
        claimDetails.hospitalRoomType = null;
      }
    }
  }, [ claimDetails, hospDetailsForRoomType ]);

  useEffect((): void => {
    if (!isRoomTypeLoading) {
      if (isNotNewAdmissionPage) {
        setIsRoomTypeLoading(true);
        if (updateRoomTypeICICI &&
          (hospDetailsForRoomType.dateOfAdmission !== stayLengthUpdated?.[0]) &&
          stayLengthUpdated?.[0]) {
          // Special case for ICICI with stay length
          dispatch(fetchProviderSpecificRoomType('', onSuccess , stayLengthUpdated?.[0]));
        } else {
          setIsRoomTypeLoading(false);
        }
      }
    }
  }, [ stayLengthUpdated ]);

  useEffect((): any => {
    if (isDeathCase && form.getFieldValue(['dateOfDischarge'])) {
      form.validateFields(['dateOfDischarge']);
    } else {
      clearValidationError(['dateOfDischarge']);
    }
  }, [isDeathCase]);

  const prefillRoomType = (HISRoomType: string): any => {
    // find a match in providerRoomType if it's not empty
    if (!isEmpty(providerRoomType)) {
      const hospitalRoomType =
        findKeyValuePair(providerRoomType, 'name', HISRoomType, true) || {};
      const { providerRoomType: hospitalRoomTypeValue } = hospitalRoomType;
      if (hospitalRoomTypeValue !== undefined) {
        form.setFieldsValue({ hospitalRoomType: hospitalRoomTypeValue });
        onChangeProviderRoomType(hospitalRoomTypeValue, true);
        // If match found in providerRoomType, exit
        return;
      }
    }

    // If no match found in providerRoomType try to find a match in payerRoomTypeOptions
    if (!isEmpty(payerRoomTypeOptions)) {
      const { payerMasterValue: payerRoomType } =
        findKeyValuePair(payerRoomTypeOptions, 'name', HISRoomType, true) || {};
      if (payerRoomType !== undefined) {
        form.setFieldsValue({ hospitalRoomType: isDetailPage ? 'Others' : OTHER_ID });
        dispatch(toggleOtherRoomType(true));
        form.setFieldsValue({ payerRoomType });
        dispatch(setHospitalOtherRoomType(payerRoomType));
      }
    }
  };
  useEffect((): void => {
    const HISRoomType = doctorDetails?.roomType;
    // calling prefillRoomType only hospDetailsForRoomType is not empty that is after we fetch provider specific room type
    if (HISRoomType && !isEmpty(hospDetailsForRoomType) && !hasPrefilledRoomTypeRef.current) {
      if (isNewAdmissionPage && !isDraftSelected) {
        prefillRoomType(HISRoomType);
        hasPrefilledRoomTypeRef.current = true;
      } else if (isEmpty(claimDetails?.hospitalRoomType) && isEmpty(claimDetails?.roomType) &&
        isEmpty(draftTreatmentDetails?.hospitalRoomType) && isEmpty(draftTreatmentDetails?.payerRoomType)) {
        // check if claimDetails or draft has roomType values if yes then don't prefill
        prefillRoomType(HISRoomType);
        hasPrefilledRoomTypeRef.current = true;
      }
    }
  }, [providerRoomType, hospDetailsForRoomType, doctorDetails, claimDetails]);

  const onSearchDoctor = (): void => {
    const { doctor } = extraFormValues;
    form.setFieldsValue({ doctorRegNo: '' });
    setDisableDocRegNo(false);
    if (doctor) {
      dispatch(setExtraFormValues({ ...extraFormValues, doctor: undefined }));
    } else {
      dispatch(setSelectedDoctorList({}));
    }
  };

  useEffect((): void => {
    if (dateDifference > 0) {
      if (dateChanged) {
        validateDate();
      }
      if (payer.shortName === 'HDFC') {
        dispatch(setHoursDifference(Math.floor(dateDifference) + 1));
      }
      if (payer?.shortName === 'ICICI' && !isRpaPayer && !isOnMailPayer && stayLength[0]) {
        dispatch(setDefaultClaim(true));
      }
    }
  }, [dateDifference]);

  const validateDate = (): any => {
    if (isValidStayLength(stayLength)) {
      form.validateFields(['stayLength']);
      setLengthOfStay(dateDifference);
      if (updateRoomTypeICICI &&
        (hospDetailsForRoomType.dateOfAdmission !== stayLength?.[0]) &&
        stayLength?.[0]) {
        // Special case for ICICI with stay length
        setIsRoomTypeLoading(true);
        dispatch(fetchProviderSpecificRoomType('', onSuccess , stayLength?.[0]));
      }
      if (dateDifference > MAX_LOS_ALLOWED_WITHOUT_WARNING) {
        form.resetFields(['LOSgt90']);
        defaultTimeline['remarks']['Remarks for LOS >90 days'] = undefined;
        dispatch(updateDefaultTimeline(defaultTimeline));
        setIsLOSgtWarning(true);
        setPopConfirmCancel(false);
      } else {
        if (!isOnMailPayer) {
          const stayLengthISO = convertToISOStrings(stayLength);
          const payload = {
            patientName: selectedBeneficiaryDetail?.memberName || fullName,
            doa: stayLengthISO?.[0],
            dod: stayLengthISO?.[1],
            memberId: selectedBeneficiaryDetail?.memberId,
            payerId: selectedBeneficiaryDetail?.payerId || payer?.id,
            schemeType: productCodeInBenefPayer ? payer?.productCode :
            (selectedBeneficiaryDetail?.productCode || payer?.productCode),
            action: 'NEWADMISSION',
          };
          isNewAdmissionPage && dispatch(checkDuplicateClaim(payload));
        }
        setIsLOSgtWarning(false);
        defaultTimeline['remarks']['Remarks for LOS >90 days'] = undefined;
        form.resetFields(['LOSgt90']);
        dispatch(updateDefaultTimeline(defaultTimeline));
      }
    }
  };

  const setSelectedTime = (admitDate: any, dischargeDate: any, admitTime: any, dischargeTime: any): void => {
    form.setFieldsValue({ stayLength: [admitDate?.concat(' ', admitTime), dischargeDate?.concat(' ', dischargeTime)] });
    if (admitDate !== '' && !dischargeDate) {
      setDateChanged(true);
      if (checkIfDelayedAdmsission(form, pathname, formElementCount?.length > 0, doaDifferenceLimit)) {
        form.resetFields(['delayedAdmissionRemark']);
        dispatch(setDelayedAdmission(true));
        setIsDelayModalVisible(true);
        setDelayedIntimationCancel(false);
      } else {
        dispatch(setDelayedAdmission(false));
        defaultTimeline['remarks']['Remarks for delayed intimation'] = undefined;
        form.resetFields(['delayedAdmissionRemark']);
        dispatch(updateDefaultTimeline(defaultTimeline));
      }
    }
  };

  const onSelectDoctor = (...option: any[]): void => {
    const { key } = option[1];
    if (key) {
      const activeDoctorList = isHISSearchEnabled && hisDoctorList?.length > 0 ? hisDoctorList : doctorList;
      const selectedDoctor = activeDoctorList?.find(({ value }: any): boolean => value === parseInt(key, 10));
      if (selectedDoctor) {
        dispatch(setSelectedDoctorList(selectedDoctor));
        const { registrationNo, name: doctor } = selectedDoctor;
        if (registrationNo) {
          form.setFieldsValue({ doctorRegNo: registrationNo });
          setDisableDocRegNo(true);
        }
        if (doctor) {
          form.setFieldsValue({ doctorName: doctor });
        }
      }
    }
    dispatch(setExtraFormValues({ ...extraFormValues, doctor: option[1] }));
  };
  const setBooleanInCard = (selectedIcdCodes: string[]): void => {
    if ( !showCard) {
      let isMaternityOpen = false;
      if (payer.shortName === 'HDFC') {
        isMaternityOpen = !!intersection(selectedIcdCodes, HDFC_MATERNITY_DIAGNOSIS_TYPE).length;
      } else {
        isMaternityOpen = !!intersection(selectedIcdCodes, MATERNITY_DIAGNOSIS_TYPE).length;
      }
    if (!isMaternityOpen) {
      form.validateFields(['obstetricHistoryG', 'obstetricHistoryP', 'obstetricHistoryL', 'obstetricHistoryA', 'deliveryDate', 'maternityType']);
    }
    const isOtherTreatmentDetailOpen = isRpaPayer ? true : !!intersection(selectedIcdCodes, CONCATED_OTHER_TREATMENT_ICDS).length;
    dispatch(setCardCollapse({ ...cardCollapse, isMaternityOpen, isOtherTreatmentDetailOpen, selectedDiagnosisIds: selectedIcdCodes }));
    if (!isOtherTreatmentDetailOpen) {
      form.validateFields(['contactLensType', 'cataractType']);
    }
  }
};

  const onCancelPopConfirm = (): any => {
    form.setFieldsValue({ dateOfDischarge: '' });
    setPopConfirmCancel(true);
    setIsLOSgtWarning(false);
  };

  const onCancelDelayedIntimation = (): any => {
    setDelayedIntimationCancel(true);
  };
  const handleExsitingClaim = (event: any): any => {
    const { duplicateClaimDetails } = existingClaimError;
    const payload = event.currentTarget.value ? event.currentTarget.value : event.currentTarget.getAttribute('aria-label');
    if (payload === 'yes' && !isEmpty(duplicateClaimDetails)) {
      dispatch(updateSelectedDetail(duplicateClaimDetails));
      const { payerClaimNo: claimNo, hospActionId, payerId, productCode } = duplicateClaimDetails;
      const payerClaimNo = base64UrlEncode(claimNo);
      const isCancel = false;
      const uniquePayerId = `${payerId}${productCode || ''}`;
      history.push(`/claims/in-patient/detail/${base64UrlEncode(`${payerClaimNo}/${hospActionId}/${payerId}
      /${uniquePayerId}/${productCode}/${isCancel}`)}`);
      dispatch(setExistingClaimError({}));
    } else if (payload === 'no') {
      dispatch(setExistingClaimError({}));
    } else {
      dispatch(setExistingClaimError({ isError: true }));
    }
  };

  const clearPackageSelection = (): any => {
    if (selectedPackage.length > 0) {
      delete billDetail[selectedPackage[0].packageId];
    }
    dispatch(updatePackageSelection([]));
    dispatch(setProcedureID(0));
    dispatch(updateBillDetails({
      ...billDetail,
      Package: undefined,
      packageCheckbox: undefined,
      searchPackage: undefined,
    }));
    form.setFieldsValue({
      packageCheckbox: undefined,
      searchPackage: undefined,
      Package: undefined,
    });
  };
  const dischargeSwitchHandler = (ev: any): any => {
    dispatch(setIsDischargeCase(ev.target.checked));
  };

  const parsedPltId = (selectedPltID: string): number => {
    return parseInt(selectedPltID || '0', 10);
  };

  const shouldUseDynamicLookUp = (masterType: string): boolean => {
    return (isHDFCEnabled || (checkIsLazyLoadingMaster(masterType, lazyLoadMasterTypes || '')));
  };

  const treatmentSelected = (data: any): void => {
    const { automationProcedures = [], isSuccess } = data || {};
    if (isSuccess) {
      setSynonymResponse(data);
      const selectedPLT = parsedPltId(form?.getFieldsValue(['proposedLineOfTreatment'])?.proposedLineOfTreatment);
      automationProcedures.map((e: any): any => e?.proposedLineOfTreatmentID === selectedPLT ?
        setTreatmentMapped(e) : setTreatmentMapped(automationProcedures[0]));
        setIsProcedureMapped(true);
        setCountProceduressMapped(countProceduresMapped + 1);
    } else {
      setSynonymResponse([]);
      setIsProcedureMapped(false);
      setCountProceduressMapped(countProceduresMapped - 1);
    }
  };

  const deathCaseSwitchHandler = (ev: any): any => {
    dispatch(setIsDeathCase(ev.target.checked));
  };

  const treatmentSelectedTreatment = (data: any): void => {
    const { automationProcedures = [], isSuccess } = data || {};
    if (isSuccess) {
      setSynonymResponse(data);
      const selectedPLT = parsedPltId(form?.getFieldsValue(['proposedLineOfTreatment'])?.proposedLineOfTreatment);
      automationProcedures.map((e: any): any => e?.proposedLineOfTreatmentID === selectedPLT ?
        setTreatmentMapped(e) : setTreatmentMapped(automationProcedures[0]));
        setIsProcedureMapped(true);
        setCountProceduressMapped(countProceduresMapped + 1);
    } else {
      setSynonymResponse([]);
      setIsProcedureMapped(false);
      setCountProceduressMapped(countProceduresMapped - 1);
    }
  };
  const onChangeMappedProcedure = (): any => {
    dispatch(setPageChangeAllowed(true));
    if (!submitDisabled) {
      setTimeout((): any => {
        form?.validateFields().then((): any => {
          dispatch(setsubmitDisabled(false));
        }).catch((): any => {  // to disable submit button till the fields are filled
          dispatch(setsubmitDisabled(true));
        });
      }, 1000);
    }
    const { id, proposedLineOfTreatmentID }: any = treatmentMapped || {};
    form.setFieldsValue({ proposedLineOfTreatment: String(proposedLineOfTreatmentID) });
    onChangePLT({ target: { value: String(proposedLineOfTreatmentID) } });
    form.setFieldsValue({ automatedProcedure: String(id) });
    onAutomatedProcedureChange(String(id));
    setIsProcedureMapped(false);
  };

  const setDiagnosisBasedOnProcedures = (diagnosisIds: string[]): void => {
    form.resetFields(['diagnosis', 'diagnosisDropDown']);
    const mappedDiagnosis: any[] = [];
    const diagnosis = payerLookUp[uniqueIdentifier]?.diagnosis || [];

    if (diagnosis?.length > 0) {
      const targetIds = new Set(
        diagnosisIds?.flatMap((id: string): number[] => id?.split(',')?.map(Number)),
      );
      mappedDiagnosis.push(...diagnosis.filter((item: any): boolean => targetIds.has(item.masterLookId)));
    }
    dispatch(fetchLookup(mappedDiagnosis, 'Diagnosis'));
  };

  const onAutomatedProcedureChange = (event: any): any => {
    dispatch(updateAdditionalMandatoryDocuments([]));
    clearPackageSelection();
    setDiagnosisValue([]);
    setTreatmentValue([]);
    setIsProcedureMapped(false);
    form.resetFields(['procedure', 'procedureDropDown', 'diagnosis', 'diagnosisDropDown', 'icd10', 'eye', 'treatmentApproach', 'dialysis', 'position', 'admissionType',
      ...FINAL_OBSTETRIC_HISTORY, 'deliveryDate', 'maternityType', 'speciality', 'icd10pcs']);
    dispatch(setDynamicQuestionFields([]));
    setBooleanInCard([]);
    const diagnosisLookValues = isHDFCEnabled ?
    diagnosisDynamicLookup : payerLookUp[uniqueIdentifier]?.diagnosis;
    // setSpecialityData('');
    setCountProceduressMapped(countProceduresMapped + 1);
    const selectedPLT = parsedPltId(form?.getFieldsValue(['proposedLineOfTreatment'])?.proposedLineOfTreatment);
    // ! Setting final automated procedures list
    let finalAutomatedProcedures = [];
    if (automatedProcedureOptions?.filter(({ value }: any): boolean => value !== OTHER_ID)?.length) {
      finalAutomatedProcedures = automatedProcedureOptions;
    } else {
      finalAutomatedProcedures = getFilteredProcedureList(payerLookUp[uniqueIdentifier]?.automationProcedures, selectedPLT);
    }
    const { mandatoryDocument, diagnosis, icdCode = [] } =
    findKeyValuePair(finalAutomatedProcedures, 'id', event, true) || {};
    //     if (speciality) {
    //   // setSpecialityData(speciality);
    //   // form.setFieldsValue({speciality});
    // }
    if (event === OTHER_ID) {
      dispatch(toggleOtherProcedure(true));
      dispatch(setProcedureID(9999999999));
      customGTMEvent({
        event: 'Select Others from Treatment drop-down',
      });
    } else {
      if (form.getFieldValue('automatedProcedure') === OTHER_ID) {
        dispatch(toggleOtherProcedure(true));
      } else {
        dispatch(toggleOtherProcedure(false));
      }
      dispatch(updateAdditionalMandatoryDocuments(mandatoryDocument));
      // dispatch(setDynamicQuestionFields(questions));
      dispatch(setProcedureID(event));
      if (diagnosis) {
        if (parsedDiagProcMappingConfigLen && diagnosis?.length) {
          setDiagnosisBasedOnProcedures(diagnosis);
        } else {
          const mappedValue = Object.values(diagnosisLookValues).filter((ele: any): any => {
            return ele.masterLookId === Number(diagnosis);
          }).map((ele: any): any => {
            return ele.payerMasterValue;
          });
          mappedValue.forEach((value: any): any => {
            form.setFieldsValue({ diagnosis: Object.values({ value }) });
          });
        }
        // form.setFieldsValue({diagnosis}); Removing this for synonym logic for diagnosis mapped
       } else {
         if (event) {
           let synonymDiagnosisValue = [];
           if (synonymResponse) {
             synonymDiagnosisValue = synonymResponse['automationProcedures'] || [];
           }
           if (synonymDiagnosisValue?.length > 0) {
             const synonymMappedElement = synonymDiagnosisValue[0]['diagnosis'];
             const diagnosisValues = findKeyValuePair(diagnosisLookValues, 'masterLookId', synonymMappedElement[0]);
             const icd10value = synonymDiagnosisValue[0]['icdCode'];
             form.setFieldsValue(
               {
                 icd10: icd10value,
                 diagnosis: [diagnosisValues['payerMasterValue']],
               });
           }
         }
       }
      if (icdCode && icdCode?.length > 0) {
      const fieldToUpdate = preFillICD10PCS ? 'icd10pcs' : 'icd10'; // set icd10pcs for icici orion
        form.setFieldsValue({
          [fieldToUpdate]: icdCode?.join(', '),
      });
    }
      setBooleanInCard(icdCode);
    }
  };

  const checkVisibleFields = (event: any, key: any): boolean => {
    let isRequired = false;   // function to set fields dynamically
    const requiredJson = GO_DIGIT_PAYER ? GO_DIGIT_DYNAMIC_TREATMENT_DETAILS_JSON : VIDAL_DYNAMIC_TREATMENT_DETAILS_JSON;
    if (form.getFieldValue(event) !== undefined &&
      form.getFieldValue(event) !== null &&
      requiredJson?.[event]?.[form?.getFieldValue(event)] !== undefined) {

      const objectKeys = Object.values(requiredJson?.[event]?.[form?.getFieldValue(event)]);
      isRequired = objectKeys?.includes(key);
    }
    return isRequired;
  };

  const onChangeDynamicDiagnosisLookUp = (event: any = [], diagnosisObjects?: any): void => {
    dispatch(setPageChangeAllowed(true));
    const selectedDiagnosis = isEmpty(diagnosisObjects) ? getLookUpFullDetail(event, diagnosisDynamicLookup, true) : diagnosisObjects;
    const updatedDiagnosisOptions = isEmpty(diagnosisObjects) ? diagnosisSelectedValues : diagnosisObjects;
    selectedDiagnosis?.forEach((ele: any): any => { // to have all the values from payerlookup object based on the selected diagnosis
      if (ele?.masterLookId !== -1 && !updatedDiagnosisOptions?.some((obj: any): any => obj?.masterLookId === ele?.masterLookId)) {
        dispatch(setDiagnosisFromPayerLookUp(ele));
      }
    });
    const selectedDiagnosisIds = getSelectedDiagnosisIds(event, updatedDiagnosisOptions)?.filter((val: string): boolean => !!val);
    const { automatedProcedure } = form.getFieldsValue(['automatedProcedure']);
    const { icdCode = [] } = findKeyValuePair(automatedProcedureOptions, 'id', automatedProcedure) || {};

    const selectedDiagnosisProcedure = getSelectedDiagnosisName(event, updatedDiagnosisOptions).filter((val: string): boolean => !!val);

    form.setFieldsValue({
      icd10: icdCode?.concat(selectedDiagnosisIds).join(', '),
    });
    setBooleanInCard(icdCode?.concat(selectedDiagnosisIds));
    if (automatedProcedure === OTHER_ID) {
      dispatch(setDiagnosisValue(selectedDiagnosisProcedure));
      dispatch(setSynonymValue(selectedDiagnosisProcedure));
      dispatch(otherTreatmentSelected({ treatmentSelected }));
    }
    customGTMEvent({
      event: 'Select Diagnosis',
      diagnosis: selectedDiagnosisProcedure,
    });
  };
  const onSearchDynamicDiagnosisLookUp = (event: any = []): void => {
    dispatch(setPageChangeAllowed(true));
    if (event?.length >= 3) {
      dispatch(setDynamicLookUpForDiagnosis(event));
      customGTMEvent({
        event: 'Entered search keyword in the diagnosis field',
        keyword: event,
      });
    }
  };
  const onSearchDynamicLookUp = (event: any = [], masterType: any = ''): void => {
    dispatch(setPageChangeAllowed(true));
    if (event?.length >= 3) {
      dispatch(setDynamicLookUp({ searchText: event, masterType }));
      customGTMEvent({
        event: 'Entered search keyword in the ' + masterType + 'field',
        keyword: event,
      });
    }
  };
  const debouncedonSearchDynamicDiagnosisLookUp = debounce(onSearchDynamicDiagnosisLookUp, 300);
  const debouncedonSearchDynamicLookUp = debounce(onSearchDynamicLookUp, 300);

  const onChangeProviderRoomType = (ev: any, ignorePackageClear?: any): any => {
    if (ev === OTHER_ID) {
      dispatch(toggleOtherRoomType(true));
      setDisableHospRoom(true);
    } else {
      dispatch(toggleOtherRoomType(false));
      setDisableHospRoom(false);
    }
    if (payer.shortName === 'HDFC' && !ignorePackageClear) {
      clearPackageSelection();
    }
  };
  const onChangePayerRoomType = (ev: any): any => {
    if (ev) {
      const { payerMasterValue: payerRoomType } =
        findKeyValuePair(payerRoomTypeOptions, 'name', ev) ||
        findKeyValuePair(payerRoomTypeOptions, 'value', ev) ||
        {};
      dispatch(setHospitalOtherRoomType(payerRoomType));
    }
  };
  useEffect((): any => {
    if (isProcedureMapped) {
      dispatch(setPageChangeAllowed(false));
    } else {
      dispatch(setPageChangeAllowed(true));
    }
  }, [countProceduresMapped]);

  useEffect((): any => {
    if (claimDetails?.hospitalizationReason) {
      onChangeFields(claimDetails?.hospitalizationReason, true);
    }
    if (isDraftSelected && admissionFormVal?.treatmentDetail?.hospitalizationReason) {
      onChangeFields(admissionFormVal?.treatmentDetail?.hospitalizationReason, true); // handling-draft
    }
    const pltFromClaim = procedureType ? procedureType?.[0] : [];

    if (pltFromClaim) {
      const { value: procedureValue, id: procedureId } = pltFromClaim;

      if (isEmpty(pltMappedValue)) {
        dispatch(setPLTMappedValue(procedureValue));
      }

      if (isEmpty(proposedLineTreatmentId)) { // set plt id as in enhancement it will be empty
        dispatch(setPltID(procedureId));
      }
}

  }, []);
  const onChangeDiagnosis = (event: any = [], diagnosisObjects?: any): void => {
    dispatch(setPageChangeAllowed(true));
    const formDiagnosisOptions = isEmpty(diagnosisObjects) ? payerLookUp[uniqueIdentifier]?.diagnosis ||
      payerLookUp?.diagnosisMasterLookup[automatedProcedureId] : diagnosisObjects;
    const selectedDiagnosisIds = getSelectedDiagnosisIds(parsedDiagProcMappingConfig?.fieldMode === 'single' ? [event] : event,
      formDiagnosisOptions)?.filter((val: string): boolean => !!val);
    const { automatedProcedure } = form.getFieldsValue(['automatedProcedure']);
    const { icdCode = [] } = findKeyValuePair(automatedProcedureOptions, 'id', automatedProcedure) || {};
    const selectedDiagnosisProcedure = getSelectedDiagnosisName(event, formDiagnosisOptions)?.filter((val: string): boolean => !!val);
    const mergedIcdCodes = parsedDiagProcMappingConfigLen && !parsedDiagProcMappingConfig?.isMapIcd
      ? [...(icdCode ?? [])] : [...(icdCode ?? []), ...(selectedDiagnosisIds ?? [])];
    const distinctIcdCodes = Array.from(new Set(mergedIcdCodes))?.join(', '); // to remove duplicate icds
    const fieldToUpdate = (preFillICD10PCS && SURGICAL.toLowerCase().includes(pltMappedValue.toLowerCase())) ? // prefill icd10pcs for ICICIOrion and surgical management
    'icd10pcs' : 'icd10';
    form.setFieldsValue({
      [fieldToUpdate]: distinctIcdCodes,
    });
    setBooleanInCard(parsedDiagProcMappingConfigLen && !parsedDiagProcMappingConfig?.isMapIcd
      ? icdCode : icdCode?.concat(selectedDiagnosisIds));
    if (automatedProcedure === OTHER_ID) {
      dispatch(setDiagnosisValue(selectedDiagnosisProcedure));
      dispatch(setSynonymValue(selectedDiagnosisProcedure));
      dispatch(otherTreatmentSelected({ treatmentSelected }));
    }
    customGTMEvent({
      event: 'Select Diagnosis',
      diagnosis: selectedDiagnosisProcedure,
    });
  };

  const onChangeProcedure = (event: any = [], procedureObjects?: any): void => {
    dispatch(setPageChangeAllowed(true));
    const { automatedProcedure } = form.getFieldsValue(['automatedProcedure']);
    const procedureOptions = isEmpty(procedureObjects) ? payerLookUp[uniqueIdentifier]?.procedure : procedureObjects;
    const selectedProcedure = getSelectedDiagnosisName(event, procedureOptions).filter((val: string): boolean => !!val);
    if (automatedProcedure === OTHER_ID) {
      dispatch(setTreatmentValue(selectedProcedure));
      dispatch(setSynonymValue(selectedProcedure));
      dispatch(otherTreatmentSelected({ treatmentSelectedTreatment }));
    }
  };
  const onChangeDynamicProcedure = (event: any = [], procedureObjects?: any): void => {
    if (payer?.shortName === 'CARE' || payer.shortName === 'Galaxy') {
      const selectedProcedures = isEmpty(procedureObjects) ? getLookUpFullDetail(event, procedureDynamicLookup, true) || {}
      : procedureObjects;
      selectedProcedures?.forEach((ele: any): any => { // to have all the values from payerlookup object based on the selected procedure
        if (ele?.masterLookId !== -1 && !procedureSelectedValues?.some((obj: any): any => obj?.masterLookId === ele?.masterLookId)) {
          dispatch(setProcedureFromPayerLookUp(ele));
        }
      });
      const selectedProcedureIds = getSelectedDiagnosisIds(event, procedureSelectedValues)?.filter((val: string): boolean => !!val);
      if (selectedProcedureIds?.length) {
        form.setFieldsValue({
          icd10pcs: selectedProcedureIds?.join(', '),
        });
      }
    }
    dispatch(setPageChangeAllowed(true));
    const { automatedProcedure } = form.getFieldsValue(['automatedProcedure']);
    const selectedProcedure = getSelectedDiagnosisName(event, procedureDynamicLookup)
      .filter((val: string): boolean => !!val);
    if (automatedProcedure === OTHER_ID) {
      dispatch(setTreatmentValue(selectedProcedure));
      dispatch(setSynonymValue(selectedProcedure));
      dispatch(otherTreatmentSelected({ treatmentSelectedTreatment }));
    }
  };
  const onChangeCovid = (ev: any): any => {
    if (showCard) {
    dispatch(setIsCovidCase(ev.target.checked));
    }
  };
  const closeButton = (): any => {
    setIsProcedureMapped(false);
    dispatch(setPageChangeAllowed(true));
  };

  const getProposedLineOfTreatment = (): any => {
    if (GO_DIGIT_PAYER) {
      const filteredPlt = payerLookUp[uniqueIdentifier]?.proposedLineOfTreatment?.filter(
        (item: any): boolean => {
          return COMMON_PLT.includes(item.payerMasterValue);
        },
      );
      return (isNewAdmissionPage && !isDraftSelected) ||
        (isDraftSelected && draftKey === DRAFT_KEYS.newAdmission)
        ? [...(payerLookUp[uniqueIdentifier]?.proposedLineOfTreatment?.length) ?
          [...payerLookUp[uniqueIdentifier].proposedLineOfTreatment] :
          [...(lookUp.proposedLineOfTreatment ?? [])]]
        : filteredPlt;
    }

    // existing logic for others
    return (payerLookUp[uniqueIdentifier]?.proposedLineOfTreatment?.length)
      ? [...payerLookUp[uniqueIdentifier].proposedLineOfTreatment]
      : [...(lookUp.proposedLineOfTreatment ?? [])];
  };

  const onSearchProcedureDropDrown = (event: any): any => {
    if (event?.length > 2) {
      setProcedureDropDownOptions(payerLookUp[uniqueIdentifier]?.procedure || []);
    } else {
      setProcedureDropDownOptions([]);
    }
  };
  const onSearchDiagnosisLookUp = (event: any): any => {
    if (event?.length > 2) {
      diagnosisOptions();
      customGTMEvent({
        event: 'Entered search keyword in the diagnosis field',
        keyword: event,
      });
    } else {
      setDiagnosisDropDownOptions([]);
    }
  };

  const debouncedOnSearchDiagnosisLookUp = debounce(onSearchDiagnosisLookUp, 300);
  const diagnosisOptions = (): any => {
    const pltData = proposedLineTreatmentId ? proposedLineTreatmentId : proposedLineOfTreatmentFromForm || {};
    // checking the redux value first as if we change tab to member details and then change the value in treatmentdetails tab,
    // the previous value is considered
      if (payer.shortName === 'ICICI') {
        if (Number(pltData)) {
          setDiagnosisDropDownOptions(payerLookUp?.diagnosisMasterLookup[pltData]);
      } else {
        if (diagnosisValue.includes(String(automatedProcedureId))) {
          setDiagnosisDropDownOptions(payerLookUp?.diagnosisMasterLookup[automatedProcedureId]);
        } else {
          setDiagnosisDropDownOptions(_.uniqBy(payerLookUp[uniqueIdentifier]?.diagnosis,
            (item: any): any => item.value.toLowerCase()) || []);
        }
      }
    } else {
      setDiagnosisDropDownOptions(payerLookUp[uniqueIdentifier]?.diagnosis || []);
    }
  };
  const onChangedoctorQualificationDropDown = (ev: any): void => {
    if (payerLookUp[uniqueIdentifier]?.doctorQualification.length) {
      const doctorQualificationMappedValue = findKeyValuePair(payerLookUp[uniqueIdentifier]?.doctorQualification,
        'value', ev, true);
      form?.setFieldsValue({ doctorQualificationDropDown: doctorQualificationMappedValue?.payerMasterValue });
    }
  };

  const onChangeFields = (event: any, isRequired?: boolean): any => {
    setIsFieldsChanged(!isFieldsChanged);
    if (isRequired) {
    setOtherCards(event);
    }
  };

  const onChangePLT = (event: any): any => {
    setIsProcedureMapped(false);
    dispatch(setPageChangeAllowed(true));
    dispatch(setDiagnosisValue([]));
    dispatch(setTreatmentValue([]));
    form.resetFields([
      'procedure', 'procedureDropDown',
      'automatedProcedure',
      'diagnosis', 'diagnosisDropDown',
      'icd10',
      'eye', 'treatmentApproach', 'dialysis', 'position', 'admissionType',
      ...FINAL_OBSTETRIC_HISTORY,
      'deliveryDate', 'maternityType', 'speciality', 'icd10pcs',
    ]);
    clearPackageSelection();
    setBooleanInCard([]);
    dispatch(setDynamicQuestionFields([]));
    dispatch(setPltID(event.target.value));
    // setSpecialityData('');
    const selectedPLT = parsedPltId(event?.target?.value);
    dispatch(setPLTChanged(true));
    const pltValue = findKeyValuePair(payerLookUp[uniqueIdentifier]?.proposedLineOfTreatment, 'value', event?.target?.value) || {};
    dispatch(setPLTMappedValue(pltValue?.name));
    const { name: PLTName } = findKeyValuePair(lookUp?.proposedLineOfTreatment, 'id', event?.target?.value) || {};
    const automatedProcedures = getFilteredProcedureList(payerLookUp[uniqueIdentifier]?.automationProcedures, selectedPLT,
      parsedDiagProcMappingConfigLen ? parsedDiagProcMappingConfig?.isMapWithPLT : true);
    dispatch(
      updateAutomatedProceduresOptions(
        automatedProcedures.length > 0
          ? parsedDiagProcMappingConfigLen && !parsedDiagProcMappingConfig?.isMapWithPLT
            ? automatedProcedures : automatedProcedures.concat(PROCEDURE_OTHER_TYPES)
          : [...PROCEDURE_OTHER_TYPES],
      ));
    if (automatedProcedures?.length === 0) {
      form.setFieldsValue({ automatedProcedure: OTHER_ID });
      dispatch(toggleOtherProcedure(true));
      dispatch(setProcedureID(9999999999));
      const { value: procedure } = findKeyValuePair(payerLookUp[uniqueIdentifier]?.procedure, 'name', PLTName) || {};
      if (procedure) {
        form.setFieldsValue({ procedure: [procedure] });
      }
      onAutomatedProcedureChange(procedure);
    } else {
      dispatch(toggleOtherProcedure(false));
      form.setFieldsValue({ procedure: undefined });
    }
    onChangeFields(event?.target?.value);
    customGTMEvent({
      event: `Select ${PLTName}`,
    });
    setDiagnosisDropDownOptions([]); // clearing the state as the change of PLT should clear the options which is based on the selected PLT
  };

  const onSuccess = (response?: any, payloadUsed?: any): any => {
    setIsRoomTypeLoading(false);
    dispatch(sethospDetailsForRoomType(payloadUsed));
    if (response?.[uniqueIdentifier]?.providerRoomType?.length) {
      setDisableHospRoom(false);
      if ( updateRoomTypeICICI ) {
        form?.resetFields(['hospitalRoomType']);
      }
      // show other room type if selected room type is other but keep it enabled
      if (form?.getFieldsValue('hospitalRoomType')?.hospitalRoomType !== OTHER_ID && !isDetailPage) {
        dispatch(toggleOtherRoomType(false));
      }
    // RGI - no others option in hospital room type
    } else if (!isRoomTypeWithoutOthers) { // Fall back when hospitalroomtypes is not present
      form.setFieldsValue({ hospitalRoomType: isDetailPage ? 'Others' : OTHER_ID });
      dispatch(toggleOtherRoomType(true));
      setDisableHospRoom(true);
      onChangeProviderRoomType(OTHER_ID, true);
    }
  };

  const setOtherCards = (selectedValue: any): any => {
    if (selectedValue === 'Maternity' && showCard) { // on selection of the reason for hospitalization make cards to be visible
      dispatch(setShowAccidentCard(false));
      dispatch(setCardCollapse({...cardCollapse, isMaternityOpen: true, isOtherTreatmentDetailOpen: false, selectedDiagnosisIds: []}));

    } else if (selectedValue === 'Injury' && showCard) {
      dispatch(setShowAccidentCard(true));
      dispatch(setCardCollapse({...cardCollapse, isMaternityOpen: false, isOtherTreatmentDetailOpen: false, selectedDiagnosisIds: []}));

    } else {
      dispatch(setShowAccidentCard(false));
      dispatch(setCardCollapse({...cardCollapse, isMaternityOpen: false, isOtherTreatmentDetailOpen: false, selectedDiagnosisIds: []}));
    }
  };
// mapping the administrationroute id with value
  const onChangeRouteOfAdministration = (ev: any): void => {
    if (payerLookUp[uniqueIdentifier]?.administrationRoute.length) {
      const routeOfAdministrationMappedValue = findKeyValuePair(payerLookUp[uniqueIdentifier]?.administrationRoute,
        'value', ev, true);
      form?.setFieldsValue({ routeOfAdministration: routeOfAdministrationMappedValue?.payerMasterValue });
    }
  };
  const onChangeConditionOnDischarge = (event: any): any => {
    dispatch(setConditionOnDischarge(event));
    setIsFieldsChanged(!isFieldsChanged);
  };
  const onChangeStateMedicalCouncil = (ev: any): void => {
    if (payerLookUp[uniqueIdentifier]?.stateMedicalCouncil.length) {
      const stateMedicalCouncilMappedValue = findKeyValuePair(payerLookUp[uniqueIdentifier]?.stateMedicalCouncil,
        'value', ev, true);
      form?.setFieldsValue({ stateMedicalCouncil: stateMedicalCouncilMappedValue?.payerMasterValue });
    }
  };

  const checkShowNow = (): any => {
    return (typeof policyStartDate === 'string' && policyStartDate?.length > 0) ?
     setIsShowNow(new Date(policyStartDate), new Date(policyEndDate)) : true;
  };

  const pltClaimValue = claimDetails?.procedureType ? claimDetails?.procedureType[0]?.value : [];
  const onChangeSurgery = (): any => {
    if (payer?.shortName === 'VIDAL' && (pltMappedValue || pltClaimValue) && (pltMappedValue === 'Surgical' ||
      pltClaimValue === 'Surgical')) {
      return false;
    } else {
      return true;
    }
  };
  const onScroll = (): any => {
    customGTMEvent({
      event: 'Scroll in the diagnosis list',
    });
  };
  const debouncedScroll = debounce(onScroll, 100);

  const isFormDisabled = (key: any): boolean | undefined => {
    const isEditPage = getIsPageNameEdit(pathname) || getIsPageNameEditDischarge(pathname) || getIsPageNameReconsider(pathname);
    const isFormPresent = !!form;
    const isCorporatePayer = !!payer?.isCorporatePayer;
    const fieldValueExists = !!form?.getFieldsValue([key])[key];
    const backupValueExists = !!claimDetailBackup[key];
    return !!(isEditPage && !isFormPresent && !isCorporatePayer && fieldValueExists && backupValueExists);
  };
  // function to disable the stayLength once dates are selected in hospitalization card
  const isDateSelected = (): boolean => {
    return (getIsPageNameEdit(pathname) || getIsPageNameEditDischarge(pathname) || getIsPageNameReconsider(pathname)) &&
    !!admissionFormVal?.treatmentDetail?.stayLength;
  };

  const disableDODChange = (isDisableDOD: boolean): boolean => {
    if (!isEmpty(claimDetails)) { // disable DOD selection for Drafts of Discharge (VIDAL)
      return isDraftSelected && (isDisableDOD && (claimDetails.nextAllowStatus[0] === actions.DISCHARGE));
    } else {
      return false;
    }
  };

  useEffect((): any => {
    if (isDischarge) {
      dispatch(setIsDischargeCase(true));
    }
    if (isDeathCaseFromClaim === 'Yes') {
      dispatch(setIsDeathCase(true)); // IPP-5578
    }
    const { icd10 } = form.getFieldsValue(['icd10']);
    setBooleanInCard(String(icd10).split(',') || []);
    const doctorListToSearch = isHISSearchEnabled && !isEmpty(hisDoctorList) ? hisDoctorList : doctorList;
    // Disable the field only if the entered registration number matches a doctor in the list.
    const isExactDoctorMatch = getExactDoctorMatch(doctorListToSearch, doctorName, doctorRegNo);
    if (isExactDoctorMatch) {
      setDisableDocRegNo(true);
    }
    if (!isDetailPage) {
      const doa = stayLength?.[0] !== undefined ? stayLength?.[0] : treatmentDetail?.stayLength?.[0];
      // in drafts form values are undefined hence taking from admissionFormVal
      const dod = stayLength?.[1] !== undefined ? stayLength?.[1] : treatmentDetail?.stayLength?.[1];
      if (doa && dod) {
        form.validateFields(['stayLength']);
        setLengthOfStay(dateDifference);
        if (payer?.shortName === 'HDFC') {
          dispatch(setHoursDifference(Math?.floor(dateDifference) + 1));
        }
      }
    }
    // to handle providerRoomType on rerender of autoTreatmentDetailCard while switching tabs
    if (form?.getFieldsValue('hospitalRoomType')?.hospitalRoomType === OTHER_ID) {
      onChangeProviderRoomType(form?.getFieldsValue('hospitalRoomType')?.hospitalRoomType, true);
    }
    if (isDraftSelected) {
      if (treatmentDetail?.isDischargeCase?.[0] === 'Yes') {
        dispatch(setIsDischargeCase(true));
      }
      if (treatmentDetail?.isDeathCase?.[0] === 'Yes') {
        dispatch(setIsDeathCase(true));
      }
    }
    if (!isDraftSelected && claimDetails?.roomType) {
      dispatch(setHospitalOtherRoomType(claimDetails?.roomType?.[0]?.payerMasterValue));
    }
  }, []);

  // Clearing the Day care type value when date changes only in New admission page
  //  and draft cases
  useEffect((): void => {
    if (isNewAdmissionPage && isDateApplied && !isDaycareCase) {
      form?.resetFields(['dayCareType']);
    }
  }, [isDateApplied]);

  const clearValidationError = (fieldName: any): any => {
    // Clear validation error for the specified field
    form?.setFields([{ name: fieldName, errors: [] }]);
  };

  useEffect((): any => {
    if (admissionFormVal?.treatmentDetail && isDraftBtnClicked) {
      admissionFormVal?.treatmentDetail?.hospitalRoomType === '9999999999' ?
        dispatch(toggleOtherRoomType(true)) : dispatch(toggleOtherRoomType(false));
    }
  }, [admissionFormVal?.treatmentDetail]);

  useEffect((): void => {
    if (isDraftSelected && !isPLTChanged) {// added this condition to not take the drafted PLT values even PLT is changed
      const draftSelectedPLT = parsedPltId(admissionFormVal?.treatmentDetail?.proposedLineOfTreatment);
      const uniqId = parseInt(uniqueIdentifier, 10);
      const automatedProcedures = getFilteredProcedureList(payerLookUp[uniqId]?.automationProcedures, draftSelectedPLT,
        parsedDiagProcMappingConfigLen ? parsedDiagProcMappingConfig?.isMapWithPLT : true);
      const automatedProceduresOptions =
        automatedProcedures.length > 0 ? !parsedDiagProcMappingConfig?.isMapWithPLT ? automatedProcedures :
            automatedProcedures.concat(PROCEDURE_OTHER_TYPES)
          : [...PROCEDURE_OTHER_TYPES];
      dispatch(updateAutomatedProceduresOptions(automatedProceduresOptions));
    }
  }, [isDraftSelected, admissionFormVal, payerLookUp]);

  useEffect((): any => {
    if (!isDoctorNameFilled) {
      dispatch(setSelectedDoctorList({}));
    }
  }, [isDoctorNameFilled]);

  const getAutomationProcedure = (): Record<string, unknown> => {
    const { automatedProcedure } = treatmentDetails || {};
    const procedureKey = automatedProcedure?.id || automatedProcedure?.procedure;
    const HISAutomatedProcedure = findKeyValuePair(payerAutomationProcedures, 'id', procedureKey?.toString()) ||
      findKeyValuePair(payerAutomationProcedures, 'procedure', procedureKey, true) || {};
    return HISAutomatedProcedure;
  };

  const fetchFromRedux = (
    sourceItems: any[],
    sourceIdKey: string,
    payerLookupOptions: any[],
    itemType: string,
  ): { [key: string]: unknown[] } => {
    let processedItems: unknown[] = [];
    let unmappedIds: string[] = [];

    // map for faster lookup of original items
    const sourceItemMap: any = new Map(
      sourceItems.map((item: { [key: string]: unknown }): any => [item[sourceIdKey], item.name]),
    );

    sourceItems.forEach((item: any): void => {
      if (!item?.[sourceIdKey]) {
        processedItems.push(item.name);
      } else {
        unmappedIds.push(item[sourceIdKey]);
      }
    });

    if (!isEmpty(unmappedIds) && !isEmpty(payerLookupOptions)) {
      processedItems = unmappedIds.map((id: string): object | string | null => {
        const foundObject = findKeyValuePair(payerLookupOptions, 'payerMasterId', id);
        return foundObject || sourceItemMap.get(id) || null;
      });
      unmappedIds = [];
    }

    return { [`${itemType}Array`]: processedItems, [`${itemType}Ids`]: unmappedIds };
  };

  const fetchProcedureFromRedux = (): { [key: string]: unknown[] } => {
    return fetchFromRedux(
      treatmentDetails.procedure,
      'id',
      payerProcedureOptions,
      'procedure',
    );
  };

  const fetchDiagnosisFromRedux = (): { [key: string]: unknown[] } => {
    return fetchFromRedux(
      treatmentDetails.diagnosis,
      'icdCode',
      payerDiagnosisOptions,
      'diagnosis',
    );
  };

  const onLookUpSuccess = (masterDetails: any): void => {
    const { Diagnosis, Procedure } = masterDetails || {};

    // If diagnosis is empty, fallback to treatmentDetails.diagnosis
    const finalDiagnosis = !isEmpty(Diagnosis)
      ? Diagnosis
      : treatmentDetails?.diagnosis?.map((diag: any): string => diag.name) || [];

    // If procedure is empty, fallback to treatmentDetails.procedure
    const finalProcedure = !isEmpty(Procedure)
      ? Procedure
      : treatmentDetails?.procedure?.map((proc: any): string => proc.name) || [];

    const updatedMasterDetails = {
      ...masterDetails,
      diagnosis: finalDiagnosis,
      procedure: finalProcedure,
    };

    dispatch(setHISTreatmentValuesFromLookUp(updatedMasterDetails));
    setHISlookupIDs({}); // Resetting HISlookupIDs to avoid stale data
  };

  const onLookUpError = (): void => {
    const finalDiagnosis = treatmentDetails?.diagnosis?.map((diag: any): string => diag.name) || [];
    const finalProcedure = treatmentDetails?.procedure?.map((proc: any): string => proc.name) || [];
    const updatedMasterDetails = {
      diagnosis: finalDiagnosis,
      procedure: finalProcedure,
    };
    dispatch(setHISTreatmentValuesFromLookUp(updatedMasterDetails));
    setHISlookupIDs({}); // Resetting HISlookupIDs to avoid stale data
  };

  useEffect((): void => {
    if (isNewAdmissionPage && !isDraftSelected) {
      const pltList = getProposedLineOfTreatment();
      if (isEmpty(treatmentDetails) || isEmpty(pltList)) {
        return;
      }
      const lineOfTreatment = treatmentDetails?.proposedLineOfTreatment;
      if (isEmpty(lineOfTreatment)) {
        return;
      }
      const pltValue = getPLTValue(lineOfTreatment, pltList);
      form.setFieldsValue({ proposedLineOfTreatment: pltValue });
      onChangePLT({ target: { value: pltValue } });

      const HISAutomatedProcedure = getAutomationProcedure();
      let HISDiagnosisValues: any = {};
      let HISProcedureValues: any = {};
      if (!isEmpty(treatmentDetails?.diagnosis)) {
        HISDiagnosisValues = fetchDiagnosisFromRedux();
      }
      if (!isEmpty(treatmentDetails?.procedure)) {
        HISProcedureValues = fetchProcedureFromRedux();
      }
      const processedHISTreatmentValues = {
        HISAutomatedProcedure,
        HISDiagnosis: HISDiagnosisValues.diagnosisArray || [],
        HISProcedure: HISProcedureValues.procedureArray || [],
      };
      setHISTreatmentValues(processedHISTreatmentValues);
      if (!isEmpty(HISDiagnosisValues?.diagnosisIds) || !isEmpty(HISProcedureValues?.procedureIds)) {
        const masterIds = {
          diagnosisIds: HISDiagnosisValues?.diagnosisIds,
          procedureIds: HISProcedureValues?.procedureIds,
        };
        setHISlookupIDs(masterIds);
        dispatch(getHISTreatmentValuesFromLookUp(masterIds, onLookUpSuccess, onLookUpError));
      }
    }
  }, [selectedPatientDetail]);
  const mergeWithoutDuplicates = (
    existing: any[],
    newItems: any[],
  ): any[] => {
    const existingSet = new Set(
      existing.map((item: any): string =>
        typeof item === 'string' ? item : item?.payerMasterValue || item?.name,
      ),
    );

    const uniqueNewItems = newItems.filter((item: any): boolean => {
      const itemValue = typeof item === 'string' ? item : item?.payerMasterValue || item?.name;
      return !existingSet.has(itemValue);
    });

    return [...existing, ...uniqueNewItems];
  };

  useEffect((): void => {
    if (!isEmpty(HISTreatmentLookUpValues)) {
      let updatedHISTreatmentValues = { ...HISTreatmentValues };
      // Handle diagnosis
      if (!isEmpty(HISTreatmentLookUpValues?.diagnosis)) {
        const existingDiagnosis = updatedHISTreatmentValues.HISDiagnosis || [];
        const newDiagnosis = HISTreatmentLookUpValues.diagnosis || [];

        updatedHISTreatmentValues = {
          ...updatedHISTreatmentValues,
          HISDiagnosis: mergeWithoutDuplicates(existingDiagnosis, newDiagnosis),
        };
      }

      // Handle procedure
      if (!isEmpty(HISTreatmentLookUpValues?.procedure)) {
        const existingProcedure = updatedHISTreatmentValues.HISProcedure || [];
        const newProcedure = HISTreatmentLookUpValues.procedure || [];

        updatedHISTreatmentValues = {
          ...updatedHISTreatmentValues,
          HISProcedure: mergeWithoutDuplicates(existingProcedure, newProcedure),
        };
      }

      setHISTreatmentValues(updatedHISTreatmentValues);
    }
  }, [HISTreatmentLookUpValues]);

  const prefillAutomatedProcedure = async (): Promise<void> => {
    const { HISAutomatedProcedure } = HISTreatmentValues || {};

    if (!isEmpty(HISAutomatedProcedure)) {
      const { id: automatedProcedureID, proposedLineOfTreatmentID } = HISAutomatedProcedure;
      const formattedHISPltID = parsedPltId(proposedLineOfTreatmentID);
      const formattedSelectedPltId = parsedPltId(formPltSelectedValue);
      if (formattedHISPltID === formattedSelectedPltId) {
        form.setFieldsValue({ automatedProcedure: String(automatedProcedureID) });
        onAutomatedProcedureChange(String(automatedProcedureID));
        return;
      }
    }
    form.setFieldsValue({ automatedProcedure: OTHER_ID });
    dispatch(toggleOtherProcedure(true));
    dispatch(setProcedureID(9999999999));
  };

  const prefillDiagnosis = (): void => {
    const formDiagnosisValue = form.getFieldValue('diagnosis');
    const { HISDiagnosis } = HISTreatmentValues || {};
    if (!isEmpty(HISDiagnosis)) {
      const existingValues = new Set(formDiagnosisValue || []);
      const diagArray: string[] = [...(formDiagnosisValue || [])];
      const diagObjects: any[] = [];

      HISDiagnosis.forEach((item: any): void => {
        let valueToAdd: string;

        if (typeof item === 'string' && !(shouldUseDynamicLookUp(PAYERMASTER_TYPE.DIAGNOSIS) || noFreeTextDiagnosis)) {
          valueToAdd = item;
        } else if (typeof item === 'object' && item !== null) {
          valueToAdd = item.payerMasterValue;
          diagObjects.push(item);
        } else {
          return; // Skip invalid items
        }

        // Only add if it doesn't already exist
        if (!existingValues.has(valueToAdd)) {
          diagArray.push(valueToAdd);
          existingValues.add(valueToAdd);
        }
      });
      form.setFieldsValue({ diagnosis: diagArray });

      if (shouldUseDynamicLookUp(PAYERMASTER_TYPE.DIAGNOSIS)) {
        onChangeDynamicDiagnosisLookUp(diagArray, diagObjects);
      } else {
        onChangeDiagnosis(diagArray, diagObjects);
      }
    }
  };

  const prefillProcedure = (): void => {
    const formProcedureValue = form.getFieldValue('procedure');
    const { HISProcedure } = HISTreatmentValues || {};
    if (!isEmpty(HISProcedure)) {
      const existingValues = new Set(formProcedureValue || []);
      const procedureArray: string[] = [...(formProcedureValue || [])];
      const procedureObjects: any[] = [];

      HISProcedure.forEach((item: any): void => {
        let valueToAdd: string;

        if (typeof item === 'string' && !checkIsLazyLoadingMaster('Procedure', lazyLoadMasterTypes || '')) {
          valueToAdd = item;
        } else if (typeof item === 'object' && item !== null) {
          valueToAdd = item.payerMasterValue;
          procedureObjects.push(item);
        } else {
          return; // Skip invalid items
        }

        // Only add if it doesn't already exist
        if (!existingValues.has(valueToAdd)) {
          procedureArray.push(valueToAdd);
          existingValues.add(valueToAdd);
        }
      });

      // Set form field value with array of strings only
      form.setFieldsValue({ procedure: procedureArray });

      if (isHDFCEnabled) {
        onChangeDynamicProcedure(procedureArray, procedureObjects);
      } else {
        onChangeProcedure(procedureArray, procedureObjects);
      }
    }
  };

  const prefillEye = (): void => {
    const treatmentApproachFieldValue = approach;
    const parsedHISEyeValue = prefillHISDynamicFields(
      eye,
      DYNAMIC_FIELD_MAPPINGS['eye'],
      true);
    if (parsedHISEyeValue) {
      form.setFieldsValue({
        eye: parsedHISEyeValue,
        treatmentApproach: treatmentApproachFieldValue,
      });
    }
    if (CATARACT_EYE_TYPE_ICD_MAPPING[eye]) {
      form.setFieldsValue({ icd10: CATARACT_EYE_TYPE_ICD_MAPPING[eye] });
    }
  };

  const prefillHISTreatmentData = async (): Promise<void> => {
    await prefillAutomatedProcedure();
    prefillDiagnosis();
    prefillProcedure();
  };

  useEffect((): void => {
    if ((isNewAdmissionPage && !isDraftSelected) && formPltSelectedValue && !isEmpty(HISTreatmentValues) && isEmpty(HISlookupIDs)) {
      prefillHISTreatmentData();
    }
  }, [HISTreatmentValues, HISlookupIDs]);

  useEffect((): void => {
    if (eye) {
      prefillEye();
    }
  }, [automatedProcedureFieldValue]);

  useEffect((): any => {
    if (claimDetails?.hospitalizationReason) {
      onChangeFields(claimDetails?.hospitalizationReason, true);
    }
    if (isDraftSelected && admissionFormVal?.treatmentDetail?.hospitalizationReason) {
      onChangeFields(admissionFormVal?.treatmentDetail?.hospitalizationReason, true); // handling-draft
    }
    const pltFromClaim = procedureType ? procedureType?.[0] : [];
    if (!isEmpty(pltFromClaim)) {
      const { value: procedureValue, id: procedureId } = pltFromClaim;
      if (isEmpty(pltMappedValue)) {
        dispatch(setPLTMappedValue(procedureValue));
      }
      if (isEmpty(proposedLineTreatmentId)) { // set plt id as in enhancement it will be empty
        dispatch(setPltID(procedureId));
      }
    }
  }, []);

  return <Panel className="treatment-scroll" data-testid="treatment-detail">
    {
      !isNewAdmissionPage ? <ClaimDetailHeader /> : null
    }
    <Row gutter={GUTTOR_SPACE}>
      <DatePickerInput detail={{
        ...commonDetail,
        key: 'stayLength',
        size: 14,
        doaRightLimit: doaRightLimitValidation,
        doaLeftLimit: doaLeftLimitValidation,
        dodRightLimit: dodForValidation,
        setval: (admitDate: any, dischargeDate: any, admitTime: any, dischargeTime: any): any => {
          setSelectedTime(admitDate, dischargeDate, admitTime, dischargeTime);
        },
        setDifference : (noOfDays: any): any => setDateDifference(noOfDays),
        showNow: checkShowNow(),
        disabled: isFormDisabled('lengthOfStay') || isDateSelected(),
        policyStartDate: policyStartDate ||  selectedPolicyDetail?.policyStartDate,
        policyEndDate: policyEndDate || selectedPolicyDetail?.policyEndDate,
        popConfirmCancel,
        delayedIntimationCancel,
        delayModalVisible: isDelayModalVisible,
        lOSgtWarning: isLOSgtWarning,
        claimForm: form,
        isDetailPage,
        isDuplicateClaim: existingClaimError?.errorMessage,
        isNewAdmissionPage,
        onFocus: (): void => handleUserFocus('stayLength', setInputStates, true),
        onBlur: (): void => handleUserFocus('stayLength', setInputStates, false),
        isShowSuggestedValue: inputStates.stayLength.isShowSuggestedValue,
        rules: [{ validator: validateDateRange }],
        disableDOD: disableDODChange(isDisableDODRequired),
      }} />
      <Col md={dateDifference === 1 ?
        isInitialDischargePayer
          ? 6 : isNewAdmissionPage ? 4 : 1 : 10}>
        {isNewAdmissionPage &&
          <Row className="inpatient left-6">
            <Col className="info-circle">
              <Popover
                content={'Inpatient | Daycare: Based on DOA & DOD'}
                overlayClassName="custom-tooltip-datepicker"
                placement="bottom"
              >
                <InfoCircleFilled />
              </Popover>
            </Col>
            <DatePickerLabel dateDifference={dateDifference} payer={payer} isInitialDischargePayer={isInitialDischargePayer} />
          </Row>
        }
      </Col>
      {shouldShowDayCareTag(isDetailPage, payerClaimExtensionFields, isDaycareCase, claimDetails, stayLength,
        showDayCareInDraftFlow, isDraftBtnClicked) &&
        <FormSelect detail={{
          ...commonDetail,
          key: 'dayCareType',
          size: isInitialDischargePayer
            ? 10 : isNewAdmissionPage ? 6 : 9,
          options: getPayerConfigPropValue(customOptions, 'options', 'Pre-Auth Type') || [],
          nextStatus: status,
          onFocus: (): void => handleUserFocus('dayCareType', setInputStates, true),
          onBlur: (): void => handleUserFocus('dayCareType', setInputStates, false),
          isShowSuggestedValue: inputStates.dayCareType.isShowSuggestedValue,
        }} />}
      <FormRadioButton detail={{
        ...commonDetail,
        key: 'proposedLineOfTreatment',
        size: 24,
        options: getProposedLineOfTreatment(),
        onChange: onChangePLT,
        isShowSuggestedValue: !!treatmentDetails,
      }} />
      <FormSelect detail={{
        ...commonDetail,
        key: 'hospitalizationReason',
        size: 12,
        options: GO_DIGIT_PAYER ? REASON_FOR_HOSPITALIZATION_OPTIONS_GO_DIGIT : REASON_FOR_HOSPITALIZATION_OPTIONS,
        onChange: (event: any): void => onChangeFields(event, true),
        onFocus: (): void => handleUserFocus('hospitalizationReason', setInputStates, true),
        onBlur: (): void => handleUserFocus('hospitalizationReason', setInputStates, false),
        isShowSuggestedValue: inputStates.hospitalizationReason.isShowSuggestedValue,
      }} />
      <FormSelect detail={{
         ...commonDetail,
         key: 'systemOfMedicine',
         size: 12,
         options: ['Allopathy', 'Ayush'],
         onChange : onChangeFields,
         onFocus: (): void => handleUserFocus('systemOfMedicine', setInputStates, true),
         onBlur: (): void => handleUserFocus('systemOfMedicine', setInputStates, false),
         isShowSuggestedValue: inputStates.systemOfMedicine.isShowSuggestedValue,
      }}/>
      <FormSelect detail={{
        ...commonDetail,
        key: 'subGroup',
        size: 12,
        options: ['Ayurveda', 'Homeopathy', 'Siddha', 'Unani'],
        hidden: !checkVisibleFields('systemOfMedicine', 'subGroup'),
        onFocus: (): void => handleUserFocus('subGroup', setInputStates, true),
        onBlur: (): void => handleUserFocus('subGroup', setInputStates, false),
        isShowSuggestedValue: inputStates.subGroup.isShowSuggestedValue,
      }}/>
      {/* ICICI Procedure Radio buttons added */}
      {( pltMappedValue === 'Surgical Management' || pltClaimValue === 'Surgical Management' ) &&
        <FormRadioButton detail={{
          ...commonDetail,
          key: 'isMultipleSurgeries',
          size: 12,
          options: ['Single', 'Multiple'],
          defaultValue: 'Single',
        }} />}
    </Row>
    <Row gutter={GUTTOR_SPACE}>
      {isProcedureMapped &&
        <Space direction="vertical" style={{ width: '60%' }}>
          <Alert
            className="procedure-alert-color"
            message={<><><CloseOutlined onClick={(): any => closeButton()} id="close-express-approvals" className="close-procedure-alert" />
              <p className="alert-text">
                Select '{treatmentMapped['procedure'] || ''}' for express approvals.</p>
              </><div className="select-button-div"><Button className="select-button" size="small" type="primary"
              onClick={onChangeMappedProcedure} id="select-express-approvals">
                Select
                </Button></div></>
            }
            closable={false}
          />
        </Space>
      }
      <FormSelect detail={{
        ...commonDetail,
        key: 'automatedProcedure',
        size: 12,
        options: automatedProcedureOptions || [],
        showSearch: automatedProcedureOptions.length > 10 ? true : false,
        onChange: onAutomatedProcedureChange,
        onFocus: (): void => handleUserFocus('automatedProcedure', setInputStates, true),
        onBlur: (): void => handleUserFocus('automatedProcedure', setInputStates, false),
        isShowSuggestedValue: inputStates.automatedProcedure.isShowSuggestedValue,
      }} />
      <FormSelect detail={{
        ...commonDetail,
        key: 'diagnosis',
        size: 12,
        options: (shouldUseDynamicLookUp(PAYERMASTER_TYPE.DIAGNOSIS) ? diagnosisDynamicLookup : diagnosisDropDownOptions) || [],
        showSearch: true,
        mode: (shouldUseDynamicLookUp(PAYERMASTER_TYPE.DIAGNOSIS) || noFreeTextDiagnosis ) ? 'multiple' : 'tags',
        isBadValueCheck: true,
        badValues: lookUp.badDiagnosis || [],
        onChange: shouldUseDynamicLookUp(PAYERMASTER_TYPE.DIAGNOSIS) ? onChangeDynamicDiagnosisLookUp : onChangeDiagnosis,
        onSearch: shouldUseDynamicLookUp(PAYERMASTER_TYPE.DIAGNOSIS)
          ? debouncedonSearchDynamicDiagnosisLookUp : debouncedOnSearchDiagnosisLookUp,
        maxLengthValue: maximumValue,
        fieldLengthValue: fieldLength,
        onPopupScroll: debouncedScroll,
        onFocus: (): void => handleUserFocus('diagnosis', setInputStates, true),
        onBlur: (): void => handleUserFocus('diagnosis', setInputStates, false),
        isShowSuggestedValue: inputStates.diagnosis.isShowSuggestedValue,
      }} />
      <FormSelect detail={{
        ...commonDetail,
        key: 'diagnosisDropDown',
        size: 12,
        options: (isHDFCEnabled || parsedDiagProcMappingConfigLen) ? diagnosisDynamicLookup : diagnosisDropDownOptions || [],
        showSearch: true,
        mode: parsedDiagProcMappingConfigLen ? parsedDiagProcMappingConfig?.fieldMode :
          payer?.shortName === 'ICICI' ? 'single' : 'multiple',
        onChange: isHDFCEnabled ? onChangeDynamicDiagnosisLookUp : onChangeDiagnosis,
        onSearch: isHDFCEnabled ? debouncedonSearchDynamicDiagnosisLookUp : debouncedOnSearchDiagnosisLookUp,
        maxLengthValue: maximumValue,
        fieldLengthValue: fieldLength,
        onFocus: (): void => handleUserFocus('diagnosisDropDown', setInputStates, true),
        onBlur: (): void => handleUserFocus('diagnosisDropDown', setInputStates, false),
        isShowSuggestedValue: inputStates.diagnosisDropDown.isShowSuggestedValue,
      }} />
      {
        showOtherProcedure && (isNewAdmissionPage || getIsPageNameEdit(pathname) ||
          getIsPageNameEditDischarge(pathname) || getIsPageNameReconsider(pathname))
        && <FormSelect detail={{
          ...commonDetail,
          key: 'procedure',
          size: 12,
          options: checkIsLazyLoadingMaster('Procedure', lazyLoadMasterTypes || '') ? procedureDynamicLookup : procedureDropDownOptions,
          showSearch: true,
          mode: checkIsLazyLoadingMaster('Procedure', lazyLoadMasterTypes || '') ? 'multiple' : 'tags',
          isBadValueCheck: true,
          badValues: lookUp?.badTreatment.concat(lookUp?.badDiagnosis) || [],
          onChange: checkIsLazyLoadingMaster('Procedure', lazyLoadMasterTypes || '') ? onChangeDynamicProcedure : onChangeProcedure,
          onlyAlphaNumeric: false,
          onlyAlpha: isAlphabetsOnly > 0 ? true : false, // added this condition check for FHPL treatment field
          maxLengthValue: maximumValue,               //  as they accept only aplhabets
          fieldLengthValue: fieldLength,
          onFocus: (): void => handleUserFocus('procedure', setInputStates, true),
          onBlur: (): void => handleUserFocus('procedure', setInputStates, false),
          isShowSuggestedValue: inputStates?.procedure?.isShowSuggestedValue,
          onSearch: checkIsLazyLoadingMaster('Procedure', lazyLoadMasterTypes || '') ? (e: any): any => debouncedonSearchDynamicLookUp(e, 'Procedure')
            : onSearchProcedureDropDrown,
          label: 'Treatment Details (Enter minimum three letters)',
          rules: payer?.shortName === 'VIDAL' ? [
            {
              validator: (rule: any, value: any, callback: any): any => {
                const treatmentValue = value?.every((element: any): any => element?.length > 3);
                if (!treatmentValue) {
                  callback('Please enter a value with a minimum of 4 characters.');
                } else {
                  callback();
                }
              },
            },
          ] : [],
        }} />
      }
      {
        showOtherProcedure && (isNewAdmissionPage || getIsPageNameEdit(pathname) ||
          getIsPageNameEditDischarge(pathname) || getIsPageNameReconsider(pathname))
         && <FormSelect detail={{
          ...commonDetail,
          key: 'procedureDropDown',
          size: 12,
          options: procedureDropDownOptions,
          showSearch: true,
          mode: 'single',
          isBadValueCheck: true,
          badValues: lookUp?.badTreatment.concat(lookUp?.badDiagnosis) || [],
          onChange: onChangeProcedure,
          onSearch: onSearchProcedureDropDrown,
          onlyAlphaNumeric: false,
          maxLengthValue: maximumValue,
          fieldLengthValue: fieldLength,
          label: 'Treatment Details (Enter minimum three letters)',
        }} />
      }
            <FormTextInput detail={{
        ...commonDetail,
        key: 'sinceWhenDuration',
        size: 6,
        regex: /[^0-9 ]+/g,
        onFocus: (): void => handleUserFocus('sinceWhenDuration', setInputStates, true),
        onBlur: (): void => handleUserFocus('sinceWhenDuration', setInputStates, false),
        isShowSuggestedValue: inputStates.sinceWhenDuration.isShowSuggestedValue,
      }}
      />
      <FormSelect detail={{
        ...commonDetail,
        key: 'sinceWhenPeriod',
        label: ' ',
        size: 6,
        options: ['Days', 'Weeks', 'Months', 'Years'],  // dropdown options added as per vidal portal
        defaultValue: 'Days',
        applyStyles: isDetailPage,
        onFocus: (): void => handleUserFocus('sinceWhenPeriod', setInputStates, true),
        onBlur: (): void => handleUserFocus('sinceWhenPeriod', setInputStates, false),
        isShowSuggestedValue: inputStates.sinceWhenPeriod.isShowSuggestedValue,
      }} />
      <FormSelect detail={{
        ...commonDetail,
        key: 'conditionOnDischarge',
        options: ['Alive', 'Expired'],
        size: 12,
        onChange: onChangeConditionOnDischarge,
        onFocus: (): void => handleUserFocus('conditionOnDischarge', setInputStates, true),
        onBlur: (): void => handleUserFocus('conditionOnDischarge', setInputStates, false),
        isShowSuggestedValue: inputStates.conditionOnDischarge.isShowSuggestedValue,
      }} />
      <FormInputDate detail={{
        ...commonDetail,
        key: 'dateOfExpiry',
        size: 12,
        hidden: !checkVisibleFields('conditionOnDischarge', 'dateOfExpiry'),
      }} />
       <FormSelect detail={{
        ...commonDetail,
        key: 'surgeryType',
        options: ['Major', 'Minor', 'SupraMajor', 'Intermediate'],
        size: 12,
        hidden: onChangeSurgery(),
        onFocus: (): void => handleUserFocus('surgeryType', setInputStates, true),
        onBlur: (): void => handleUserFocus('surgeryType', setInputStates, false),
        isShowSuggestedValue: inputStates.surgeryType.isShowSuggestedValue,
      }} />
        <FormInputDate detail={{
        ...commonDetail,
        key: 'dateOfSurgery',
        size: 12,
        label: 'Date of Surgery/ Delivery',
        hidden: !onChangeSurgery() ? onChangeSurgery() : !checkVisibleFields('hospitalizationReason', 'dateOfSurgery'),
        onFocus: (): void => handleUserFocus('dateOfSurgery', setInputStates, true),
        onBlur: (): void => handleUserFocus('dateOfSurgery', setInputStates, false),
        isShowSuggestedValue: inputStates.dateOfSurgery.isShowSuggestedValue,
      }} />
          <FormSelect detail={{
        ...commonDetail,
        key: 'cataractOperatedFor',
        options: ['Left Eye', 'Right Eye', 'Both eyes'],
        required: false,
        hidden: !checkVisibleFields('proposedLineOfTreatment', 'cataractOperatedFor'),
        size: 12,
        onFocus: (): void => handleUserFocus('cataractOperatedFor', setInputStates, true),
        onBlur: (): void => handleUserFocus('cataractOperatedFor', setInputStates, false),
        isShowSuggestedValue: inputStates.cataractOperatedFor.isShowSuggestedValue,
      }} />
      <FormSelect detail={{
        ...commonDetail,
        key: 'routeOfAdministration',
        size: 12,
        options: payerLookUp[uniqueIdentifier]?.administrationRoute || [],
        onChange: onChangeRouteOfAdministration,
        onFocus: (): void => handleUserFocus('routeOfAdministration', setInputStates, true ),
        onBlur: (): void => handleUserFocus('routeOfAdministration', setInputStates, false ),
        isShowSuggestedValue: inputStates.routeOfAdministration.isShowSuggestedValue,
        nextStatus: status,
      }} />
      <FormTextInput detail={{
        ...commonDetail,
        key: 'icd10',
        size: payerConfig?.routeOfAdministration ? 6 : 12,
        disabled: true,
      }} />
      <FormTextInput detail={{
        ...commonDetail,
        key: 'icd10pcs',
        size: payerConfig?.routeOfAdministration ? 6 : 12,
        disabled: true,
      }} />
       {shouldShowReasonForEnhancement(GO_DIGIT_PAYER, isEnhancement, isDraftSelected, draftKey, isDetailPage, statusId) &&
      <FormSelect detail={{
        ...commonDetail,
        key: 'reasonForEnhancement',
        size: 12,
        mode: 'multiple',
        options: REASON_FOR_ENHANCEMENT_OPTIONS,
        nextStatus: status,
      }} />
    }
    {shouldShowReasonForReconsideration(GO_DIGIT_PAYER, isReconsider, isDraftSelected, draftKey, isDetailPage, statusId) &&
      <FormSelect detail={{
        ...commonDetail,
        key: 'reasonForReconsideration',
        size: 12,
        options: REASON_FOR_RECONSDIERATION_OPTIONS,
        nextStatus: status,
      }} />
    }
      <FormSelect detail={{
        ...commonDetail,
        key: 'treatmentType',
        size: 12,
        options: ICICI_PROCEDURES,
      }} />
    </Row>
    {dynamicQuestionFields ? dynamicQuestionFields[0]?.key ?
          <DynamicTreatmentDetailCard isLoading={isLoading} form={form}/>
        :
          <AutomatedOtherTreatmentDetailCard isLoading={isLoading} form={form} />
        : <AutomatedOtherTreatmentDetailCard isLoading={isLoading} form={form} />
    }
    {/* <Row gutter={GUTTOR_SPACE}>
        <FormSelect detail={{
            ...commonDetail,
            key: 'speciality',
            size: 12,
            options: payerLookUp[uniqueIdentifier]?.speciality || [],
            disabled: specialityData ? true : false,
        }} />
    </Row> */}
    <Row gutter={GUTTOR_SPACE}>
      <Divider />
      <Col md={12}>
        <Row gutter={GUTTOR_SPACE}>
          <FormAutoCompleteWithPrefix detail={{
            ...commonDetail,
            key: 'doctorName',
            size: 24,
            onSearch: onSearchDoctor,
            onSelect: onSelectDoctor,
            options: (payerLookUp[payer?.uniqueIdentifier]?.doctorList || [])?.filter(
              (doctor: any): boolean =>
                !doctor?.name?.toLowerCase()?.startsWith(DEFAULT_TEXT),
            ),
            isName: true,
            isPrefixRequired: true,
            showSearch: true,
            className: 'doctorClass',
            isDetailPage,
            prefix: 'Dr. ',
            onFocus: (): void => handleUserFocus('doctorName', setInputStates, true),
            onBlur: (): void => handleUserFocus('doctorName', setInputStates, false),
            isShowSuggestedValue: inputStates.doctorName.isShowSuggestedValue,
            maxLengthValue: getPayerConfigPropValue(maxPropObj, 'MAX', 'doctorName'), // to have maximum character limit
            fieldLengthValue: [getPayerConfigPropValue(maxPropObj, 'maximumLength', 'doctorName')],
            }} />
          <FormTextInput detail={{
            ...commonDetail,
            key: 'doctorQualification',
            size: 24,
            maxLengthValue: getPayerConfigPropValue(maxPropObj, 'MAX', 'doctorQualification'), // to have maximum character limit
            fieldLengthValue: [getPayerConfigPropValue(maxPropObj, 'maximumLength', 'doctorQualification')],
            onFocus: (): void => handleUserFocus('doctorQualification', setInputStates, true),
            onBlur: (): void => handleUserFocus('doctorQualification', setInputStates, false),
            isShowSuggestedValue: inputStates.doctorQualification.isShowSuggestedValue,
          }} />
          <FormSelect detail={{
            ...commonDetail,
            key: 'doctorQualificationDropDown',
            size: 24,
            allowClear: true,
            required: true,
            onChange: onChangedoctorQualificationDropDown,
            options: payerLookUp[uniqueIdentifier]?.doctorQualification?.length > 0 ?
              payerLookUp[uniqueIdentifier]?.doctorQualification : (DOCTOR_QUALIFICATION_DROPDOWN),
            onFocus: (): void => handleUserFocus('doctorQualificationDropDown', setInputStates, true),
            onBlur: (): void => handleUserFocus('doctorQualificationDropDown', setInputStates, false),
            isShowSuggestedValue: inputStates.doctorQualificationDropDown.isShowSuggestedValue,
          }} />
          <FormSelect detail={{
            ...commonDetail,
            key: 'doctorSpecialization',
            size: 24,
            allowClear: true,
            required: true,
            options: payerLookUp[uniqueIdentifier]?.doctorSpecialization?.length > 0 ?
              payerLookUp[uniqueIdentifier]?.doctorSpecialization : [],
            onFocus: (): void => handleUserFocus('doctorSpecialization', setInputStates, true),
            onBlur: (): void => handleUserFocus('doctorSpecialization', setInputStates, false),
            isShowSuggestedValue: inputStates.doctorSpecialization.isShowSuggestedValue,
          }} />
          <FormInputMobile detail={{
            ...commonDetail,
            key: 'doctorMobileNo',
            size: 24,
            isExtraRuleReq: getPayerConfigPropValue(payerConfigValues, 'extraRegex', 'doctorMobileNo'),
            onFocus: (): void => handleUserFocus('doctorMobileNo', setInputStates, true),
            onBlur: (): void => handleUserFocus('doctorMobileNo', setInputStates, false),
            isShowSuggestedValue: inputStates.doctorMobileNo.isShowSuggestedValue,
          }} />
          <FormSelect detail={{
            ...commonDetail,
            key: 'hospitalRoomType',
            size: 24,
            options: (providerRoomType?.length ? providerRoomType.concat(OTHER_ROOM_TYPE) : OTHER_ROOM_TYPE),
            showSearch: true,
            onChange: onChangeProviderRoomType,
            disabled: disableRoomType || disableHospRoom,
            onFocus: (): void => handleUserFocus('hospitalRoomType', setInputStates, true),
            onBlur: (): void => handleUserFocus('hospitalRoomType', setInputStates, false),
            isShowSuggestedValue: inputStates.hospitalRoomType.isShowSuggestedValue,
          }} />
          {
            showOtherRoomType &&
            <FormSelect detail={{
              ...commonDetail,
              key: 'payerRoomType',
              size: 24,
              options: (payerRoomTypeOptions || []),
              showSearch: true,
              disabled: disableRoomType,
              onChange: onChangePayerRoomType,
              onFocus: (): void => handleUserFocus('payerRoomType', setInputStates, true),
              onBlur: (): void => handleUserFocus('payerRoomType', setInputStates, false),
              isShowSuggestedValue: inputStates.payerRoomType.isShowSuggestedValue,
            }} />
          }
          {
            showOtherRoomType &&
            <FormTextInput detail={{
              ...commonDetail,
              key: 'roomTypeText',
              size: 24,
              disabled: disableRoomType,
              onFocus: (): void => handleUserFocus('roomTypeText', setInputStates, true),
              onBlur: (): void => handleUserFocus('roomTypeText', setInputStates, false),
              isShowSuggestedValue: inputStates.roomTypeText.isShowSuggestedValue,
            }}
            />
          }
        </Row>
      </Col>
      <Col md={12}>
        <Row gutter={GUTTOR_SPACE}>
          <FormTextInput detail={{
            ...commonDetail,
            key: 'doctorRegNo',
            size: 24,
            disabled: disableDocRegNo,
            regex: /[^a-zA-Z\d-]*/gm,
            onFocus: (): void => handleUserFocus('doctorRegNo', setInputStates, true),
            onBlur: (): void => handleUserFocus('doctorRegNo', setInputStates, false),
            isShowSuggestedValue: inputStates.doctorRegNo.isShowSuggestedValue,
          }} />
          <FormSelect detail={{
            ...commonDetail,
            key: 'stateMedicalCouncil',
            size: 24,
            onChange: onChangeStateMedicalCouncil,
            options: payerLookUp[uniqueIdentifier]?.stateMedicalCouncil || [],
            showSearch: true,
            onFocus: (): void => handleUserFocus('stateMedicalCouncil', setInputStates, true),
            onBlur: (): void => handleUserFocus('stateMedicalCouncil', setInputStates, false),
            isShowSuggestedValue: inputStates.stateMedicalCouncil.isShowSuggestedValue,
          }} />
          <FormTextInput detail={{
            ...commonDetail,
            key: 'stateMedicalCouncilText',
            size: 24,
            onFocus: (): void => handleUserFocus('stateMedicalCouncilText', setInputStates, true),
            onBlur: (): void => handleUserFocus('stateMedicalCouncilText', setInputStates, false),
            isShowSuggestedValue: inputStates.stateMedicalCouncilText.isShowSuggestedValue,
          }} />
          <FormTextInput detail={{
            ...commonDetail,
            key: 'newPackageName',
            size: 24,
          }} />
          <FormTextInput detail={{
            ...commonDetail,
            key: 'presentComplaints',
            size: 24,
            ...(GO_DIGIT_PAYER ? {
              hidden: !checkVisibleFields('hospitalizationReason', 'presentComplaints'),
            } : undefined),
            maxLengthValue: maximumValue,
            fieldLengthValue: fieldLength,
            onlyAlphabet: isAlphabetsOnly > 0 ? true : false, // Restricting Special Characters and Digits
            onFocus: (): void => handleUserFocus('presentComplaints', setInputStates, true),
            onBlur: (): void => handleUserFocus('presentComplaints', setInputStates, false),
            isShowSuggestedValue: inputStates.presentComplaints.isShowSuggestedValue,
          }}
          />
        </Row>
      </Col>
      <Col md={24}>
        <Row gutter={GUTTOR_SPACE}>
          <FormTextArea detail={{
            ...commonDetail,
            key: 'internalRemark',
            size: 24,
            disabled: false,
          }}
          />
        </Row>
      </Col>
      <Divider />
      {(isNewAdmissionPage || isDetailPage) && <Col md={12}>
        <Row gutter={GUTTOR_SPACE}>
          <FormCheckBox
            detail={{
              ...commonDetail,
              key: 'isDischargeCase',
              options: [{ value: 'Yes', name: 'Yes', onChange: dischargeSwitchHandler }],
              size: 24,
              isShowSuggestedValue: !!doctorDetails,
            }}
          />
        </Row>
      </Col>}
      { (isNewAdmissionPage || isDetailPage || isEditDischarge) &&  <Col md={12}>
        <Row gutter={GUTTOR_SPACE}>
          <FormCheckBox detail={{
            ...commonDetail,
            key: 'isDeathCase',
            options: [{ value: 'Yes', name: 'Yes', onChange: deathCaseSwitchHandler }],
            size: 24,
            showSearch: true,
            disabled: false,
            isShowSuggestedValue: !!doctorDetails,
          }} />
        </Row>
      </Col>}
    </Row>
      <Row gutter={GUTTOR_SPACE}>
      <FormCheckBox
        detail={{
          ...commonDetail,
          key: 'isCovidCase',
          options: [{ value: 'Yes', name: 'Yes', onChange: onChangeCovid }],
          size: 24,
          isShowSuggestedValue: !!doctorDetails,
        }}
      />
      </Row>
    <Modal
      visible={existingClaimError?.errorMessage}
      onCancel={handleExsitingClaim}
      footer={
        <Row>
          <Col span={2} offset={16}>
            <Button key="draft" data-testid="save-draft-modal" value="yes" onClick={handleExsitingClaim} type="primary">
              Yes
            </Button>
          </Col>
          <Col span={2} offset={2}>
            <Button key="cancel" data-testid="click-on-cancel" value="no" onClick={handleExsitingClaim}>No</Button>
          </Col>
        </Row>
      }
    >
      <InfoCircleTwoTone className="fsize_lg" />&nbsp;
      {existingClaimError?.errorMessage}
    </Modal>
    {
      isDelayedAdmission && <DelayedIntimationPopUP
        visible={isDelayModalVisible}
        setVisible={setIsDelayModalVisible}
        isLoading={isLoading}
        form={form}
        claimDetailBackup={claimDetailBackup}
        onCancel={onCancelDelayedIntimation}
      />
    }
    {
      isLOSgtWarning &&
      <PopuponLateDod
        visible={isLOSgtWarning}
        setVisible={setIsLOSgtWarning}
        lengthOfStay={lengthOfStay}
        form={form}
        onCancelPopConfirm={onCancelPopConfirm}
      />
    }
  </Panel>;
};
export default withRouter(AutoTreatmentDetailCard);
